import {effect, inject, Injectable} from "@angular/core";
import {MatPaginatorIntl} from "@angular/material/paginator";
import {TranslateService} from "@ngx-translate/core";
import {TranslateHelperService} from "./translate-helper.service";

@Injectable({
    providedIn: "root",
})
export class PaginatorInternationalization extends MatPaginatorIntl {
    private readonly translateService = inject(TranslateService);
    private readonly translateHelperService = inject(TranslateHelperService);
    private readonly langChanged = this.translateHelperService.lang;

    protected translationKeys = new Map<string, { translationKey: string }>([
        ["itemsPerPageLabel", {translationKey: "general.paginator.items-per-page"}],
        ["rangeLabelEmpty", {translationKey: "general.paginator.range-empty"}],
        ["rangeLabel", {translationKey: "general.paginator.range"}],
        ["firstPageLabel", {translationKey: "general.paginator.first-page"}],
        ["lastPageLabel", {translationKey: "general.paginator.last-page"}],
        ["nextPageLabel", {translationKey: "general.paginator.next-page"}],
        ["previousPageLabel", {translationKey: "general.paginator.previous-page"}],
    ]);

    constructor() {
        super();
        this.translateLabels();
        effect(() => {
            if (this.langChanged()) {
                this.translateLabels();
            }
        });
    }

    /* eslint-disable @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-non-null-assertion,@typescript-eslint/no-unsafe-return */
    private translateLabels(): void {
        this.itemsPerPageLabel = this.translateService.instant(this.translationKeys.get("itemsPerPageLabel")!.translationKey);
        this.firstPageLabel = this.translateService.instant(this.translationKeys.get("firstPageLabel")!.translationKey);
        this.lastPageLabel = this.translateService.instant(this.translationKeys.get("lastPageLabel")!.translationKey);
        this.nextPageLabel = this.translateService.instant(this.translationKeys.get("nextPageLabel")!.translationKey);
        this.previousPageLabel = this.translateService.instant(this.translationKeys.get("previousPageLabel")!.translationKey);
        this.getRangeLabel = (page: number, pageSize: number, length: number): string => {
            if (length === 0) {
                return this.translateService.instant(this.translationKeys.get("rangeLabelEmpty")!.translationKey);
            }
            const start = page * pageSize + 1;
            const end = Math.min((page + 1) * pageSize, length);
            return this.translateService.instant(
                this.translationKeys.get("rangeLabel")!.translationKey, {start, end, length},
            );
        };
        this.changes.next();
    }

    /* eslint-enable @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-non-null-assertion,@typescript-eslint/no-unsafe-return */

}
